import {Button, Group, Modal, Text} from '@mantine/core';
import React from 'react';

/** Confirmation shown before regenerating an API key, which deletes the existing one. */
export function RegenerateAPIKeyConfirmModal({
  onConfirm,
  onRequestClose,
}: {
  onConfirm: () => void;
  onRequestClose: () => void;
}): JSX.Element {
  return (
    <Modal
      title="Confirm API key regeneration"
      opened={true}
      onClose={onRequestClose}
      closeButtonProps={{'aria-label': 'Close'}}
    >
      <Text>Generating a new API key will delete your current one. Are you sure?</Text>
      <Group position="right" spacing="sm" mt="lg">
        <Button variant="tertiary" onClick={onRequestClose} data-autofocus={true}>
          Cancel
        </Button>
        <Button variant="warn" onClick={onConfirm}>
          Regenerate
        </Button>
      </Group>
    </Modal>
  );
}

export default RegenerateAPIKeyConfirmModal;
